import type { Instance } from './instance';

export const TeamStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export type TeamStatus = (typeof TeamStatus)[keyof typeof TeamStatus];

export const RunnerStrategy = {
  LOCAL: 'local',
  SSH: 'ssh',
  HOST: 'host',
  RELAY: 'relay',
  MIXED: 'mixed',
} as const;

export type RunnerStrategy = (typeof RunnerStrategy)[keyof typeof RunnerStrategy];

export const MessageType = {
  TEXT: 'text',
  TASK_ASSIGNMENT: 'task_assignment',
  STATUS_UPDATE: 'status_update',
  SHUTDOWN_REQUEST: 'shutdown_request',
} as const;

export type MessageType = (typeof MessageType)[keyof typeof MessageType];

export interface Team {
  id: string;
  projectId: string;
  name: string;
  description: string | null;
  status: TeamStatus;
  leadInstanceId: string | null;
  runnerStrategy: RunnerStrategy;
  preferredSshHostIds: string[] | null;
  encryptionEnabled: boolean;
  relaySessionId: string | null;
  createdAt: string;
  updatedAt: string;
  instances?: Instance[];
}

export interface InstanceMessage {
  id: string;
  teamId: string;
  fromInstanceId: string;
  toInstanceId: string | null;
  content: string;
  messageType: MessageType;
  isRead: boolean;
  createdAt: string;
  fromInstance?: { id: string; agent?: { name: string } };
  toInstance?: { id: string; agent?: { name: string } } | null;
}

export interface CreateTeamDto {
  name: string;
  description?: string;
  agentIds: string[];
  taskIds?: string[];
  runnerStrategy?: RunnerStrategy;
  preferredSshHostIds?: string[];
  encryptionEnabled?: boolean;
  permissionMode?: string;
  runtime?: string;
  leadAgentId?: string;
  spawnMode?: string;
}

export interface SendMessageDto {
  fromInstanceId: string;
  toInstanceId?: string;
  content: string;
}
